import { inject, Injectable } from '@angular/core';
import { limit, orderBy } from '@angular/fire/firestore';
import { Functions, httpsCallable } from '@angular/fire/functions';
import { Notification, RequestNotification } from '@models';
import { FirestoreService } from './firestore.service';
import { TenantContextService } from './tenant-context.service';

@Injectable({
  providedIn: 'root',
})
export class NotificationsAdminService {
  private readonly firestore = inject(FirestoreService);
  private readonly tenantContext = inject(TenantContextService);
  private readonly functions = inject(Functions);

  readonly notifications$ = this.firestore.listDocuments<Notification>(
    this.tenantContext.collections.NOTIFICATIONS,
    orderBy('createdAt', 'desc'),
    limit(20),
  );

  sendNotifications(requestNotification: RequestNotification) {
    const callable = httpsCallable<RequestNotification, void>(
      this.functions,
      'adminSendPushNotification',
    );
    return callable(requestNotification);
  }
}
